export const DEFAULT_PHONE_COUNTRY_CODE = '+48';

export const formatPhoneNumber = (phoneNumber: string, phoneExt: string) => {
  // additional check for unexpected null values
  if (!phoneNumber) return '';

  const sanitizedPhoneNumber = sanitizePhoneNumber(phoneNumber);

  return `${phoneExt} ${sanitizedPhoneNumber.replace(/(.{3})/g, '$1 ').trim()}`;
};

export const sanitizePhoneNumber = (phoneNumber: string) => {
  // additional check for unexpected null values
  if (!phoneNumber) return '';

  return phoneNumber.replace(/\s/g, '').trim();
};

export const formatPhoneNumberToDisplay = (phoneNumber: string) => {
  // additional check for unexpected null values
  if (!phoneNumber) return '';

  const sanitizedPhoneNumber = sanitizePhoneNumber(phoneNumber);

  return sanitizedPhoneNumber.replace(/(.{3})/g, '$1 ').trim();
};
